var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 99.5,
    stroke: "#FE372F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1186_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.712 104.665C126.362 104.06 124.792 104.295 123.682 105.285L102.887 123.8C101.947 124.635 101.487 125.885 101.667 127.135L105.017 150.52C105.217 151.925 106.282 153.01 107.627 153.46L108.737 153.635C109.772 153.635 110.817 153.205 111.552 152.465C123.397 140.615 129.922 124.86 129.922 108.09C129.927 106.61 129.062 105.27 127.712 104.665Z",
    fill: "#FE1C13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9177 70.0703C75.1477 70.0703 59.3877 76.5953 47.5427 88.4403L47.3677 88.6103C46.3627 89.6153 46.0127 91.1003 46.4627 92.4453C46.9127 93.7953 48.0827 94.7703 49.4877 94.9703L72.8727 98.3203L73.4027 98.3603C74.4627 98.3603 75.4877 97.9103 76.2027 97.1053L94.7177 76.3103C95.7027 75.2053 95.9427 73.6303 95.3377 72.2803C94.7327 70.9353 93.3927 70.0703 91.9177 70.0703Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3928 135.754C98.4328 135.754 97.4728 135.384 96.7428 134.654L65.3478 103.259C63.9428 101.854 63.8778 99.5937 65.2028 98.1087L88.7328 71.7537C105.398 52.2487 132.453 39.5087 156.328 40.0187C158.328 40.0637 159.943 41.6787 159.988 43.6787C160.538 67.4187 147.763 94.6037 128.193 111.324L101.898 134.799C101.178 135.439 100.288 135.754 99.3928 135.754Z",
    fill: "#FE372F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.668 86.8311C122.463 86.8311 119.263 85.6111 116.828 83.1761C111.958 78.3011 111.958 70.3711 116.828 65.4961C121.703 60.6211 129.633 60.6211 134.508 65.4961C139.378 70.3711 139.378 78.3011 134.508 83.1761C132.068 85.6161 128.868 86.8311 125.668 86.8311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7476 159.998C42.7676 159.998 41.8076 159.613 41.0976 158.898C40.1226 157.923 39.7626 156.493 40.1576 155.168C41.4126 150.963 47.9576 129.723 53.0676 124.618C59.0326 118.658 69.4226 118.658 75.3776 124.618C78.3576 127.603 79.9976 131.558 79.9976 135.778C79.9976 139.993 78.3576 143.953 75.3776 146.933C70.2726 152.038 49.0276 158.583 44.8276 159.843L43.7476 159.998Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1877 70.0918C74.0677 70.5268 58.9827 77.0018 47.5377 88.4418L47.3677 88.6118C46.3627 89.6168 46.0127 91.1018 46.4627 92.4468C46.9127 93.7968 48.0827 94.7718 49.4877 94.9718L65.9027 97.3268L88.7327 71.7518C89.2077 71.1968 89.6927 70.6418 90.1877 70.0918Z",
    fill: "#FE1C13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.933 40C132.093 40 106.613 51.895 90.1878 70.09C89.6928 70.64 89.2078 71.19 88.7278 71.75L65.9028 97.325L65.2028 98.11C63.8778 99.595 63.9428 101.855 65.3478 103.26L81.0478 118.96L116.828 83.18C111.958 78.305 111.958 70.375 116.828 65.5C119.263 63.065 122.468 61.845 125.668 61.845C128.868 61.845 132.073 63.065 134.508 65.5L158.893 41.115C158.233 40.455 157.328 40.04 156.328 40.015C155.863 40.005 155.398 40 154.933 40Z",
    fill: "#FE372F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1186_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(40 40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.32bbe1023dfb1c12da4c013e84bdf244.svg";
export { ForwardRef as ReactComponent };